import { render, staticRenderFns } from "./personnel_detail.vue?vue&type=template&id=2c8265e9&"
import script from "./personnel_detail.vue?vue&type=script&lang=js&"
export * from "./personnel_detail.vue?vue&type=script&lang=js&"
import style0 from "./personnel_detail.vue?vue&type=style&index=0&id=2c8265e9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports